import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { submitNetlifyForm } from "@/lib/netlifyForm";
import { useHumanCheck, HumanCheckField } from "@/components/HumanCheck";

// Inscription douce : un seul message au lancement, sans compteur ni promesse de date.
export const NewsletterSignup = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", "bot-field": "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const check = useHumanCheck();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    if (!check.isValid) {
      setError("Réponse incorrecte à la question de vérification.");
      check.regenerate();
      return;
    }
    setLoading(true);
    try {
      await submitNetlifyForm("newsletter", form);
      navigate("/merci-newsletter");
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        navigate("/merci-newsletter");
        return;
      }
      setError("L'envoi a échoué. Vérifiez votre connexion et réessayez.");
      setLoading(false);
    }
  };

  return (
    <form
      name="newsletter"
      method="POST"
      data-netlify="true"
      netlify-honeypot="bot-field"
      onSubmit={submit}
      className="mt-10 max-w-xl"
    >
      <input type="hidden" name="form-name" value="newsletter" />
      <p className="hidden" aria-hidden="true">
        <label>
          Ne pas remplir : <input name="bot-field" tabIndex={-1} autoComplete="off" onChange={set("bot-field")} value={form["bot-field"]} />
        </label>
      </p>
      <label htmlFor="newsletter-email" className="block text-sm font-bold uppercase tracking-wide text-paper mb-3">
        Prévenez-moi au lancement
      </label>
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          id="newsletter-email"
          name="email"
          type="email"
          required
          value={form.email}
          onChange={set("email")}
          data-testid="newsletter-email"
          placeholder="Votre adresse électronique"
          className="flex-1 bg-paper text-ink border border-transparent rounded-[10px] px-4 py-3 text-base focus:outline-none focus:border-orange transition-colors duration-200"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className="inline-flex items-center justify-center gap-2 bg-orange text-ink font-bold uppercase tracking-wide px-6 py-3.5 rounded-[10px] hover:bg-paper hover:text-ink transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
        >
          {loading ? "Envoi…" : "Prévenez-moi"} <ArrowRight size={17} />
        </button>
      </div>
      <div className="mt-4">
        <HumanCheckField check={check} dark testid="newsletter-human-check" />
      </div>
      {error && (
        <p role="alert" data-testid="newsletter-error" className="mt-3 text-sm font-medium text-highlight">{error}</p>
      )}
      <p className="mt-3 text-sm text-paper/60 leading-relaxed">
        Un seul message, le jour de la première publication. Aucune lettre d'information régulière,
        aucune donnée transmise à des tiers.
      </p>
    </form>
  );
};
